import { Button } from "@material-ui/core";
import React from "react";
import { StatusWrapper, UserWrapper, UserContainer } from "./UserData.style";

function UserData({ content, handleClickOpen, handleMissingMedScreen }) {
  return (
    <UserContainer>
      <UserWrapper>
        <span>
          Order ID:
          <span className="detail-value">{content?.orderId}</span>
        </span>
        <span>
          Customer Name:
          <span className="detail-value">{content?.customerName}</span>
        </span>
        <span>
          Invoice Date:
          <span className="detail-value">{content?.invoiceDate}</span>
        </span>
        <span>
          Payment Type:
          <span className="detail-value">{content?.paymentType}</span>
        </span>
        <span>
          Order Value:
          <span className="detail-value">₹{content?.orderValue}</span>
        </span>
        {content?.pickerName ? (
          <span>
            Picker Name:
            <span className="detail-value">{content?.pickerName}</span>
          </span>
        ) : (
          ""
        )}
      </UserWrapper>
      <StatusWrapper>
        <Button
          variant="contained"
          style={{ backgroundColor: "#2ecc71", color: "#fff" }}
          onClick={() => handleClickOpen(181)}
          disabled={content && content.packageStatus === 181 ? true : false}
        >
          Box Verified
        </Button>
        <Button
          variant="contained"
          style={{ backgroundColor: "#e74c3c", color: "#fff" }}
          onClick={() => handleMissingMedScreen()}
        >
          Medicine Missing
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={() => handleClickOpen(231)}
        >
          Correction
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={() => handleClickOpen(182)}
        >
          Cold Chain
        </Button>
      </StatusWrapper>
    </UserContainer>
  );
}

export default UserData;
